var DEFAULT_STYLES = {
  fontFamily: 'Arial',
  fontWeight: 'normal',
  fontSize: 12,
  strokeWidth: null,
  fillColor: null,
  textAlign: 'left',
  strokeColor: null,
};

var STYLE_NAMES_MAP = {
  'font-weight': 'fontWeight',
  'font-size': 'fontSize',
  'font-family': 'fontFamily',
  stroke: 'strokeColor',
  fill: 'fillColor',
  'stroke-width': 'strokeWidth',
};

export default {
  currentStyles: DEFAULT_STYLES,

  getNodeClassNameStyles: function (node) {
    var classname = node.getAttribute && node.getAttribute('class');

    if (!classname) return;

    var chunks = classname.trim().split(' ');

    if (chunks.length === 0) {
      return null;
    } else if (chunks.length === 1) {
      return this.globalStyles[chunks[0]];
    } else {
      var styles = [{}];
      chunks.forEach((item) => {
        arr.push(this.globalStyles[item]);
      });
      return _.extend.apply(_, styles);
    }
  },

  getNodeStyles: function (node) {
    var attrs = this.getNodeClassNameStyles(node) || {};

    [].forEach.call(node.attributes, function (attr) {
      var name = STYLE_NAMES_MAP[attr.name];
      if (!name) return;
      attrs[name] = attr.value;
    });

    return attrs;
  },

  getNodeStylesDiff: function (nodeStyles) {
    var styles = this.currentStyles;
    var result = [];
    var keys = Object.keys(nodeStyles);

    keys.forEach(function (name) {
      let value = nodeStyles[name];

      if (value === styles[name]) return;

      result.push({
        name: name,
        prev: styles[name],
        next: value,
      });
    });

    return result;
  },

  getCTXPropertyName: function (value) {
    return {
      font: 'font',
      fillColor: 'fillStyle',
      strokeColor: 'strokeStyle',
      strokeWidth: 'lineWidth',
    }[value];
  },

  getNodeTransforms: function (node) {
    var attr = node.getAttribute && node.getAttribute('transform');

    if (!attr) {
      return;
    }

    var result = [];
    var debug = this.debug;

    attr
      .trim()
      .replace(/\)\s+/g, ')@_@')
      .split('@_@')
      .forEach(function (chunk) {
        var bits = chunk.match(/(\w+)\((.*?)\)/);
        var name = bits[1];
        var value = bits[2].trim().split(/[\,\s]+/);

        switch (name.toLowerCase()) {
          case 'translate':
            return result.push({
              name: 'translate',
              args: [+value[0] || 0, +value[1] || 0],
            });

          case 'rotate':
            var angle = +value[0];
            if (value.length === 1) {
              return result.push({
                name: 'rotate',
                args: [(angle * Math.PI) / 180],
              });
            } else {
              return result.push(
                {
                  name: 'translate',
                  args: [+value[1], +value[2]],
                },
                {
                  name: 'rotate',
                  args: [(angle * Math.PI) / 180],
                },
                {
                  name: 'translate',
                  args: [-value[1], -value[2]],
                },
              );
            }

          case 'matrix':
            return result.push({
              name: 'transform',
              args: value,
            });

          case 'scale':
            return result.push({
              name: 'scale',
              args: value.map(function (val) {
                return +val;
              }),
            });
        }
      });

    return result;
  },
};
